import { motion } from "framer-motion";

const JumpingIcon = ({ size, icon}) => {
  const MotionIcon = motion(icon);

  return (
    <MotionIcon size={size} animate={{ y: [0, -10, 0] }} transition={{ repeat: Infinity, duration: 2 }}/>
  );
};

export default JumpingIcon;
